import { Control, Controller } from "react-hook-form";
import Typography from "../../../typography/typography";
import ToggleSwitch, {
  ISwitchProps,
} from "../../../toggle-switch/toggle-switch";
import { memo } from "react";

interface IDynamicToggleButton {
  formControl: Control<any>;
  fieldArrayName: string;
  name: string;
  label: string;
  position: number;
  disabled?: boolean;
  titlePosition?: "start" | "end";
  typeOfField?: string;
  title: string;
  toggleSwitchProps?: ISwitchProps;
}

const DynamicToggleButton: React.FC<IDynamicToggleButton> = memo(({
  formControl,
  fieldArrayName,
  name,
  label,
  position,
  disabled,
  titlePosition,
  title,
  toggleSwitchProps,
}) => {
	return (
		<Controller
			control={formControl}
			name={`${fieldArrayName}.${name}`}
			render={({ field }) => (
				<>
					<Typography
						type='s5'
						color='theme.secondary.800'
						weight="medium"
						data-position={position}
						sx={{ mb: 0.5 }}>
						{label}
					</Typography>
					<ToggleSwitch
						{...toggleSwitchProps}
						name={name}
						checked={Boolean(field.value)}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							field.onChange(e.target.checked);
						}}
						label={title}
						disabled={Boolean(disabled)}
						labelPosition={titlePosition}	
					/>
				</>
			)}
		/>
	);
});

export default DynamicToggleButton;
